import { BroadCastListPage } from './broadCast.list.page';

export default BroadCastListPage;
